import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCesiumComponent } from './simple-icons-cesium.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCesiumComponent ],
    exports:      [ SimpleIconsCesiumComponent ],
    bootstrap:    []
})
export class SimpleIconsCesiumModule {}
